/** المرحلة 8 (المالية والتحليلات) — نصوص لوحة التحكم بالعربية. تُضاف إلى `admin.ar.ts` (ADR-801)؛ المصطلحات: docs/I18N_GLOSSARY.md و docs/faz-8/CEVIRI_TERIMLERI.md. */
export const adminFaz8Ar = {
  reports: {
    navGroup: 'التقارير والمشتريات',
    period: 'الفترة',
    presets: {
      this_month: 'هذا الشهر',
      last_month: 'الشهر الماضي',
      last_7: 'آخر 7 أيام',
      last_30: 'آخر 30 يومًا',
      last_90: 'آخر 90 يومًا',
      this_year: 'هذا العام',
      last_year: 'العام الماضي',
      custom: 'نطاق مخصص',
    },
    from: 'من',
    to: 'إلى',
    interval: 'التجميع حسب',
    intervals: { day: 'يوم', week: 'أسبوع', month: 'شهر', year: 'سنة' },
    all: 'الكل',
    csv: 'تنزيل CSV',
    xlsx: 'تنزيل Excel',
    print: 'طباعة / PDF',
    printedAt: 'تاريخ الطباعة: {{date}}',
    vsNamed: '{{name}}: {{value}}',
    vsPrevious: 'الفترة السابقة: {{value}}',
    deltaUp: 'ارتفاع بنسبة {{pct}}%',
    deltaDown: 'انخفاض بنسبة {{pct}}%',
    deltaFlat: 'لا تغيير',
    deltaNew: 'لا شيء في الفترة السابقة',
    partial: 'لم تنتهِ الفترة بعد؛ قد تتغير أرقام اليوم.',
    currencyNote:
      'المبالغ بالليرة التركية (TRY). تُحوَّل الطلبات بالعملات الأجنبية بسعر شراء العملات الأجنبية لدى TCMB وقت الطلب؛ وتُحتسب المرتجعات والإلغاءات في الفترة التي قُدِّم فيها الطلب.',
    empty: 'لا توجد بيانات لهذه الفترة.',
    none: 'غير محدد',
    loadingAgain: 'جارٍ التحديث…',
    chartEmpty: 'لا توجد مبيعات لعرضها في الرسم البياني.',
    tooltip: '{{bucket}}: {{value}}',
    dashboard: {
      noPermission: 'يتطلب عرض أرقام المبيعات صلاحية تقارير المبيعات.',
      tilesLabel: 'ملخص المبيعات',
      today: 'صافي المبيعات اليوم',
      todayOrders: 'طلبات اليوم',
      yesterday: 'أمس',
      last30: 'صافي المبيعات، آخر 30 يومًا',
      last30Orders: 'الطلبات، آخر 30 يومًا',
      chartTitle: 'آخر 30 يومًا: صافي المبيعات اليومي (شامل ضريبة القيمة المضافة)',
      open: 'فتح تقرير المبيعات',
    },
    share: 'الحصة',
  },
  salesReport: {
    tilesTitle: 'ملخص الفترة',
    navLabel: 'تقرير المبيعات',
    store: 'المتجر',
    channel: 'القناة',
    segment: 'نوع العميل',
    channels: { web: 'متجر الويب', b2b: 'بوابة الموزّعين', manual: 'طلب من لوحة التحكم', api: 'API' },
    segments: { retail: 'التجزئة', dealer: 'الموزّع' },
    tiles: {
      netSales: 'صافي المبيعات',
      orders: 'الطلبات',
      averageOrder: 'متوسط قيمة الطلب',
      deductions: 'المرتجعات والإلغاءات',
      newCustomers: 'العملاء الجدد',
    },
    chartTitle: 'صافي المبيعات (شامل ضريبة القيمة المضافة)',
    summaryTitle: 'من الإجمالي إلى الصافي',
    rows: {
      productGross: 'إجمالي مبيعات المنتجات (قبل الخصومات)',
      discounts: 'الخصومات',
      shipping: 'رسوم الشحن والدفع عند الاستلام',
      orderTotal: 'قيمة الطلبات',
      cancellations: 'المبلغ الملغى',
      refunds: 'المبلغ المسترد',
      deductions: 'المرتجعات والإلغاءات',
      netSales: 'صافي المبيعات (شامل ضريبة القيمة المضافة)',
      tax: 'ضريبة القيمة المضافة',
      netSalesExVat: 'صافي المبيعات (غير شامل ضريبة القيمة المضافة)',
      itemsSold: 'عدد القطع المبيعة',
      cancelledOrders: 'الطلبات الملغاة بالكامل',
      customers: 'العملاء الذين قدّموا طلبات',
      returningCustomers: 'العملاء العائدون',
      newCustomerNetSales: 'صافي المبيعات من العملاء الجدد',
      returningCustomerNetSales: 'صافي المبيعات من العملاء العائدين',
    },
    thisPeriod: 'هذه الفترة',
    previousPeriod: 'الفترة السابقة',
    deductionNote:
      '«المرتجعات والإلغاءات» هي القيمة الأكبر بين المبلغ الملغى والمبلغ المسترد: إذ يجب استرداد مبلغ الطلب المدفوع قبل إلغائه، لذا لا يُجمع المبلغان.',
    seriesTitle: 'جدول الفترات',
    columns: {
      bucket: 'بداية الفترة',
      orders: 'الطلبات',
      orderTotal: 'قيمة الطلبات',
      deductions: 'المرتجعات والإلغاءات',
      netSales: 'صافي المبيعات',
      netSalesExVat: 'غير شامل الضريبة',
      averageOrder: 'متوسط قيمة الطلب',
      name: 'الاسم',
      quantity: 'الكمية',
    },
    total: 'الإجمالي',
    awaiting: 'طلبات بانتظار الدفع: {{count}} ({{amount}})؛ تُحتسب عند الدفع.',
    fxMissing: 'لا يتوفر سعر صرف لـ {{count}} من الطلبات بالعملات الأجنبية؛ وقد استُبعدت من التقرير.',
    breakdownTitle: 'التفصيل',
    breakdown: 'التفصيل حسب',
    breakdowns: {
      product: 'المنتج',
      variant: 'المتغير (SKU)',
      category: 'الفئة',
      brand: 'العلامة التجارية',
      country: 'الدولة',
      channel: 'القناة',
      store: 'المتجر',
      segment: 'نوع العميل',
      paymentMethod: 'طريقة الدفع',
    },
    categoryNote:
      'يُحتسب المنتج المدرج في عدة فئات ضمن كل فئة منها؛ لذا قد يتجاوز مجموع الفئات الإجمالي العام. وتُحسب الحصة من الإجمالي العام.',
    lineNote:
      'تعتمد أرقام المنتجات على مبالغ البنود شاملةً ضريبة القيمة المضافة، بعد خصم الوحدات الملغاة والتخفيض بنسبة استرداد الطلب؛ ولا يدخل الشحن فيها.',
    showing: 'الصفوف المعروضة: {{shown}} من أصل {{total}}؛ ويحتوي الملف عليها جميعًا.',
  },
  financeInputs: {
    navLabel: 'المدخلات المالية',
    section: 'القسم',
    sections: {
      fees: 'رسوم الدفع',
      shipments: 'تكاليف الشحن',
      shippingRules: 'تقديرات تكلفة الشحن',
      expenses: 'مصاريف التشغيل',
    },
    readOnly: 'يمكنك عرض هذه الأرقام؛ ويتطلب تغييرها صلاحية إدارة المدخلات المالية.',
    providers: {
      iyzico: 'iyzico (بطاقة)',
      paytr: 'PayTR (بطاقة)',
      bank_transfer: 'تحويل بنكي',
      cash_on_delivery: 'الدفع عند الاستلام',
      open_account: 'حساب آجل',
      manual: 'يدوي (تحويل بنكي، نقد، إلخ)',
    },
    provider: 'طريقة الدفع',
    installments: 'التقسيط',
    allInstallments: 'جميع خيارات التقسيط الأخرى',
    installmentN: '{{n}} أقساط',
    singlePayment: 'دفعة واحدة',
    rate: 'النسبة (%)',
    fixedFee: 'رسوم ثابتة لكل معاملة',
    validFrom: 'صالح من',
    validTo: 'صالح حتى',
    openEnded: 'مفتوح المدة',
    note: 'ملاحظة',
    addFeeRule: 'إضافة قاعدة رسوم',
    editFeeRule: 'تعديل قاعدة الرسوم',
    saveFeeRule: 'حفظ القاعدة',
    feeRuleSaved: 'تم حفظ قاعدة الرسوم.',
    feeRuleDeleted: 'تم حذف قاعدة الرسوم.',
    confirmDeleteFee: 'هل تريد حذف قاعدة الرسوم هذه؟ ستتغير الرسوم المحسوبة في التقرير المالي.',
    emptyFees: 'لا توجد قواعد رسوم',
    emptyFeesLead:
      'أدخل النسب الواردة في عقدك مع مزوّد الدفع. وإلى أن تُدخلها تظهر الرسوم في التقرير المالي بعبارة «لا توجد بيانات».',
    rateInvalid: 'أدخل نسبة بين 0 و50 (مثال: 2.49).',
    amountInvalid: 'أدخل مبلغًا (مثال: 125.50).',
    filter: 'عرض',
    filters: { all: 'جميع الشحنات', missing: 'لم تُدخل التكلفة', entered: 'أُدخلت التكلفة' },
    carrier: 'شركة الشحن',
    allCarriers: 'جميع شركات الشحن',
    shipmentsSummary:
      'الشحنات: {{shipments}} · التكلفة المُدخلة (شاملة ضريبة القيمة المضافة): {{entered}} (لـ {{enteredCount}} من الشحنات) · التكلفة المقدّرة (غير شاملة ضريبة القيمة المضافة): {{estimated}} · مجهولة التكلفة: {{unknown}}',
    columns: {
      date: 'التاريخ',
      order: 'الطلب',
      carrier: 'شركة الشحن',
      tracking: 'رقم التتبع',
      weight: 'الوزن',
      cost: 'التكلفة',
      source: 'المصدر',
      provider: 'طريقة الدفع',
      installments: 'التقسيط',
      rate: 'النسبة',
      fixedFee: 'الرسوم الثابتة',
      validity: 'فترة السريان',
      maxWeight: 'الحد الأقصى للوزن',
      category: 'الفئة',
      description: 'الوصف',
      amount: 'المبلغ (شامل ضريبة القيمة المضافة)',
      vat: 'ضريبة القيمة المضافة',
      reference: 'رقم المستند',
      store: 'المتجر',
    },
    estimated: 'تقديرية، غير شاملة ضريبة القيمة المضافة',
    unknownCost: 'غير معروفة',
    sources: { manual: 'يدوي', import: 'من ملف' },
    enterCost: 'إدخال التكلفة',
    editCost: 'تعديل تكلفة الشحن',
    newCost: 'تكلفة الشحن: {{tracking}}',
    amount: 'المبلغ (شامل ضريبة القيمة المضافة)',
    vat: 'مبلغ ضريبة القيمة المضافة',
    reference: 'رقم الفاتورة / المستند',
    entryDate: 'تاريخ المستند',
    saveCost: 'حفظ التكلفة',
    costSaved: 'تم حفظ تكلفة الشحن.',
    costDeleted: 'تم حذف تكلفة الشحن.',
    confirmDeleteCost: 'هل تريد حذف تكلفة الشحن لهذه الشحنة؟',
    emptyShipments: 'لا توجد شحنات في هذه الفترة',
    import: 'رفع فاتورة شركة الشحن',
    importTitle: 'ملف فاتورة شركة الشحن',
    importLead:
      'ملف CSV أو Excel: العمودان «Takip no» (رقم التتبع) و«Tutar» (المبلغ) إلزاميان؛ والأعمدة «KDV» (ضريبة القيمة المضافة) و«Fatura no» (رقم الفاتورة) و«Tarih» (التاريخ) اختيارية. تُعرض معاينة أولًا، وتُحفظ التكاليف عند التأكيد.',
    file: 'الملف',
    preview: 'معاينة',
    apply: 'حفظ الصفوف المطابقة',
    overwrite: 'استبدال التكاليف الموجودة بمبالغ الملف',
    importSummary: 'صفوف جاهزة: {{ready}} · شحنات لها تكلفة بالفعل: {{exists}} · صفوف بها مشكلات: {{errors}}',
    importApplied: 'تم حفظ تكلفة الشحن لـ {{count}} من الشحنات.',
    rowStatus: { ready: 'جاهز', exists: 'مُدخل بالفعل', error: 'مشكلة' },
    row: 'الصف',
    status: 'الحالة',
    problem: 'التفاصيل',
    addRule: 'إضافة قاعدة تقدير',
    editRule: 'تعديل قاعدة التقدير',
    saveRule: 'حفظ القاعدة',
    ruleSaved: 'تم حفظ قاعدة التقدير.',
    ruleDeleted: 'تم حذف قاعدة التقدير.',
    confirmDeleteRule: 'هل تريد حذف قاعدة التقدير هذه؟',
    maxWeight: 'الحد الأقصى للوزن لكل طرد (kg)',
    noLimit: 'بلا حد',
    cost: 'التكلفة لكل شحنة (غير شاملة ضريبة القيمة المضافة)',
    emptyRules: 'لا توجد قواعد تقدير',
    emptyRulesLead: 'أدخل قائمة أسعار شركة الشحن؛ وعندئذٍ تُقدَّر تكلفة الشحنات التي لم تُدخل تكلفتها.',
    kg: '{{kg}} kg',
    category: 'الفئة',
    allCategories: 'جميع الفئات',
    categories: {
      rent: 'الإيجار',
      salary: 'الرواتب والموظفون',
      marketing: 'التسويق (عدا الإعلانات)',
      software: 'البرمجيات والاشتراكات',
      packaging: 'التغليف',
      logistics: 'المستودع والخدمات اللوجستية',
      utilities: 'الكهرباء والماء والإنترنت',
      professional: 'المحاسبة والشؤون القانونية والاستشارات',
      tax_fees: 'الضرائب والرسوم',
      other: 'أخرى',
    },
    expenseDate: 'التاريخ',
    description: 'الوصف',
    store: 'المتجر',
    noStore: 'المنشأة بالكامل',
    addExpense: 'إضافة مصروف',
    editExpense: 'تعديل المصروف',
    saveExpense: 'حفظ المصروف',
    expenseSaved: 'تم حفظ المصروف.',
    expenseDeleted: 'تم حذف المصروف.',
    confirmDeleteExpense: 'هل تريد حذف هذا المصروف؟',
    emptyExpenses: 'لا توجد مصاريف في هذه الفترة',
    emptyExpensesLead:
      'أدخل الإيجار والرواتب والبرمجيات والتكاليف المماثلة؛ إذ تدخل في حساب صافي الربح والتدفق النقدي. أما الإنفاق الإعلاني فيأتي من مركز الإعلانات.',
    expensesTotal: 'الإجمالي: {{amount}} (ضريبة القيمة المضافة {{vat}})',
  },
  financeReport: {
    navLabel: 'التقرير المالي',
    tiles: {
      revenue: 'الإيرادات (دون ضريبة القيمة المضافة)',
      grossProfit: 'إجمالي الربح',
      contribution: 'هامش المساهمة',
      operatingProfit: 'الربح التشغيلي',
      netCash: 'صافي التدفق النقدي',
    },
    marginOf: 'النسبة من الإيرادات: {{pct}}',
    grossUnknown: 'بعض المبيعات بلا تكلفة؛ قد يبدو إجمالي الربح أعلى من حقيقته.',
    pnlTitle: 'الربحية (على أساس الطلبات، دون ضريبة القيمة المضافة)',
    rows: {
      netSales: 'صافي المبيعات (شامل ضريبة القيمة المضافة)',
      revenue: 'الإيرادات (صافي المبيعات، دون ضريبة القيمة المضافة)',
      cogs: 'تكلفة البضاعة المباعة (COGS)',
      grossProfit: 'إجمالي الربح',
      shipping: 'تكلفة الشحن',
      fees: 'رسوم الدفع',
      ads: 'الإنفاق الإعلاني',
      disputes: 'خسائر اعتراضات الدفع ورسومها',
      contribution: 'هامش المساهمة',
      expenses: 'المصروفات التشغيلية',
      operatingProfit: 'الربح التشغيلي',
    },
    statuses: { complete: 'مكتملة', partial: 'جزئية', missing: 'لا توجد بيانات' },
    notes: {
      cogsUnknown:
        'تكلفة مبيعات بقيمة {{amount}} غير معروفة؛ لذا يبدو إجمالي الربح أعلى من حقيقته. هامش الربح الإجمالي في البنود المعروفة التكلفة: {{pct}}.',
      cogsUnknownAll: 'تكلفة مبيعات بقيمة {{amount}} غير معروفة؛ لذا يبدو إجمالي الربح أعلى من حقيقته.',
      cogsLate: 'سُجّلت تكلفة بقيمة {{amount}} لاحقًا (تقديرية).',
      shippingEstimated: 'حُسب مبلغ {{amount}} وفق قواعد التقدير.',
      shippingUnknown: 'تكلفة {{count}} شحنات غير معروفة (لم تُدخل، ولا توجد قاعدة تقدير).',
      feesUnknown: 'لا توجد قاعدة رسوم لـ {{count}} من الدفعات بالبطاقة.',
      adsMissing: 'لا يوجد حساب إعلاني مرتبط؛ احتُسب الإنفاق الإعلاني صفرًا.',
      adsFx: 'لا يتوفر سعر صرف لبعض أيام الإنفاق الإعلاني بالعملة الأجنبية.',
      disputes:
        '{{count}} اعتراضات خاسرة أو مقبولة: {{lost}} (شامل ضريبة القيمة المضافة؛ على افتراض أن البضاعة لم تُرجَع) ورسوم الاعتراضات {{fees}}.',
    },
    goInputs: 'الانتقال إلى المدخلات المالية',
    pnlCols: { item: 'البند', amount: 'المبلغ', share: 'النسبة من الإيرادات', status: 'حالة البيانات' },
    expenseOf: 'مصروف: {{name}}',
    cashFx: 'استُبعدت من التدفق النقدي {{count}} دفعات بعملة أجنبية دون سعر صرف.',
    dealerCollectionsHidden:
      'تحصيلات الموزّعين على مستوى المنشأة بأكملها؛ لذا تُخفى عند تطبيق مرشّح المتجر أو القناة أو البيع بالتجزئة، وللمستخدمين المقيّدين بمتاجر محددة.',
    inByMethod: 'المدفوعات المستلمة: {{name}}',
    noData: 'لا توجد بيانات لعرضها في هذه الفترة.',
    noProducts: 'لم يُبع أي منتج في هذه الفترة.',
    showingProducts: 'يتم عرض أول {{count}} منتج حسب الإيرادات.',
    cashTitle: 'التدفق النقدي (حسب تاريخ المعاملة)',
    cashRows: {
      in: 'النقد الوارد',
      dealerCollections: 'تحصيلات الموزّعين (الحساب الجاري)',
      out: 'النقد الصادر',
      refunds: 'المبالغ المستردة',
      fees: 'رسوم الدفع',
      shipping: 'مدفوعات شركات الشحن (شامل ضريبة القيمة المضافة)',
      expenses: 'المصروفات التشغيلية (شامل ضريبة القيمة المضافة)',
      ads: 'الإنفاق الإعلاني',
      suppliers: 'مدفوعات المورّدين',
      disputes: 'اعتراضات الدفع (المبلغ المفقود والرسوم)',
      net: 'صافي التدفق النقدي',
    },
    cashNote: 'عرض تقريبي لأغراض الإدارة، وليس مطابقة للحساب البنكي. تُحسب الرسوم وفق قواعد الرسوم لديك.',
    vatTitle: 'ملخص ضريبة القيمة المضافة',
    vatRows: {
      output: 'ضريبة القيمة المضافة على المبيعات',
      inputExpenses: 'ضريبة القيمة المضافة المدفوعة على المصروفات',
      inputShipping: 'ضريبة القيمة المضافة المدفوعة على الشحن',
      inputPurchases: 'ضريبة القيمة المضافة في فواتير المورّدين (المشتريات)',
      difference: 'الفرق',
    },
    vatNote:
      'تأتي ضريبة القيمة المضافة على المشتريات من فواتير المورّدين المسجّلة عند استلام البضائع. هذا ليس إقرارًا ضريبيًا — تحقّق منه مع المحاسب القانوني.',
    balancesTitle: 'الذمم المدينة والدائنة (اليوم)',
    balanceRows: {
      dealerReceivables: 'ذمم الموزّعين المدينة (عدد الموزّعين المدينين: {{count}})',
      openDisputes: 'اعتراضات الدفع المفتوحة — المبلغ المعرّض للخطر (عدد الاعتراضات: {{count}})',
      codInTransit: 'مبالغ الدفع عند الاستلام قيد الشحن (عدد الطلبات: {{count}})',
      supplierPayables: 'ذمم المورّدين الدائنة (عدد المورّدين: {{count}} · المتأخر {{overdue}})',
    },
    dealerScopeHidden: 'غير معروض: وصولك مقتصر على بعض المتاجر',
    openDisputesLink: 'فتح الاعتراضات',
    feesTitle: 'رسوم الدفع حسب طريقة الدفع',
    feeCols: {
      provider: 'طريقة الدفع',
      processed: 'مبلغ المعاملات',
      fee: 'الرسوم',
      noRule: 'مدفوعات بلا قاعدة',
    },
    productsTitle: 'ربحية المنتجات',
    productCols: {
      product: 'المنتج',
      revenue: 'الإيرادات (دون ضريبة القيمة المضافة)',
      cogs: 'تكلفة البضاعة المباعة',
      grossProfit: 'إجمالي الربح',
      margin: 'الهامش',
    },
    unknownCost: 'التكلفة غير معروفة',
    estimatedCost: 'تكلفة تقديرية',
    channelsTitle: 'ربحية القنوات',
    channelCols: {
      channel: 'القناة',
      revenue: 'الإيرادات',
      cogs: 'تكلفة البضاعة المباعة',
      shipping: 'الشحن',
      fees: 'الرسوم',
      contribution: 'هامش المساهمة (دون الإعلانات)',
    },
    reconTitle: 'مطابقة المدفوعات',
    reconCols: {
      provider: 'المزوّد',
      status: 'آخر مطابقة',
      finished: 'التاريخ',
      open: 'الفروق غير المحسومة',
    },
    reconStatus: { running: 'قيد التنفيذ', ok: 'متطابقة', mismatch: 'توجد فروق', error: 'خطأ' },
    reconEmpty: 'لم تُجرَ أي مطابقة بعد.',
    openPayments: 'الانتقال إلى المدفوعات',
    missingTitle: 'المنتجات المباعة دون تكلفة',
    missingLead:
      'المنتجات التي بيعت في هذه الفترة دون تكلفة (الأكثر مبيعًا أولًا). أدخل التكلفة في صفحة المنتج؛ تُستخدم في الطلبات اللاحقة، وتُسجَّل للطلبات السابقة على أنها «تقديرية».',
    missingCols: { product: 'المنتج', sku: 'SKU', quantity: 'الوحدات المباعة' },
    missingNone: 'كل المنتجات المباعة في هذه الفترة لها تكلفة.',
    coverage: 'التكلفة وقت البيع: {{snapshot}} بند · سُجّلت لاحقًا: {{late}} · غير معروفة: {{missing}}',
  },
  stockReport: {
    navLabel: 'تقرير المخزون',
    warehouse: 'المستودع',
    allWarehouses: 'جميع المستودعات',
    slowDays: 'حد بطء الحركة',
    slowDaysOption: 'دون مبيعات خلال {{days}} يومًا',
    tilesTitle: 'ملخص المخزون',
    tiles: {
      value: 'قيمة المخزون',
      units: 'الوحدات المتوفرة',
      turnover: 'معدل الدوران (الفترة)',
      daysOfInventory: 'مدة بقاء المخزون',
      slow: 'المخزون بطيء الحركة',
    },
    unitsSub: '{{count}} متغيرات في المخزون',
    valueSub: 'بالتكلفة الحالية، دون ضريبة القيمة المضافة',
    unknownCostSub: '{{count}} وحدة بلا تكلفة',
    turnoverValue: '{{x}} مرة',
    turnoverSub: '{{sold}} وحدة مباعة · متوسط المخزون {{avg}} وحدة',
    daysValue: '{{days}} يومًا',
    noSales: 'لا توجد مبيعات في الفترة',
    slowSub: '{{count}} متغيرات · {{units}} وحدة',
    costHidden:
      'ليست لديك صلاحية عرض التكاليف، لذا تُخفى قيمة المخزون وأعمدة التكلفة؛ أما الوحدات ومعدل الدوران فمكتملة.',
    method:
      'قيمة المخزون = الوحدات المتوفرة × التكلفة الحالية للمنتج (دون ضريبة القيمة المضافة؛ وتُحوَّل التكلفة بالعملة الأجنبية بآخر سعر شراء للعملات لدى TCMB). تُحدَّث تكلفة المنتج عند استلام البضائع وفق متوسط التكلفة المرجّح المتحرك.',
    negative: '{{count}} وحدة برصيد سالب (بيعت قبل استلامها)؛ لم تُدرج في القيمة.',
    fxMissing: 'لا يتوفر سعر صرف لعملة تكلفة {{count}} متغيرات؛ لم تُدرج في القيمة.',
    alertsTitle: 'مخزون يحتاج إلى متابعة',
    alerts: {
      expired: 'منتهي الصلاحية',
      expiring: 'تنتهي صلاحيته خلال {{days}} يومًا',
      critical: 'عند المستوى الحرج أو دونه',
    },
    alertUnits: '{{units}} وحدة',
    alertVariants: '{{count}} متغيرات',
    goStock: 'فتح في شاشة المخزون',
    warehousesTitle: 'المخزون حسب المستودع',
    warehouseCols: {
      warehouse: 'المستودع',
      variants: 'المتغيرات',
      units: 'الوحدات المتوفرة',
      value: 'قيمة المخزون',
      unknown: 'وحدات بلا تكلفة',
    },
    inactive: 'غير نشط',
    categoriesTitle: 'المخزون حسب الفئة',
    categoryNote:
      'يُحتسب المنتج المدرج في أكثر من فئة ضمن كل منها؛ لذا قد يتجاوز مجموع الصفوف الإجمالي العام.',
    categoryCols: {
      category: 'الفئة',
      units: 'الوحدات المتوفرة',
      value: 'قيمة المخزون',
      sold: 'المباع في الفترة',
    },
    variantsTitle: 'المخزون ومعدل الدوران حسب المتغير',
    slowTitle: 'المنتجات بطيئة الحركة',
    slowLead: 'المتغيرات التي لها مخزون ولم تُبع خلال آخر {{days}} يومًا (حسب قيمة المخزون).',
    slowNone: 'لا توجد منتجات بطيئة الحركة.',
    variantCols: {
      product: 'المنتج',
      onHand: 'المتوفر',
      available: 'القابل للبيع',
      unitCost: 'تكلفة الوحدة',
      value: 'قيمة المخزون',
      sold: 'المباع في الفترة',
      turnover: 'معدل الدوران',
      cover: 'مدة التغطية',
      lastSale: 'آخر بيع',
    },
    noCost: 'بلا تكلفة',
    uncategorized: 'بدون فئة',
    never: 'لم يُبع قط',
    showing:
      'يتم عرض أول {{shown}} متغير من أصل {{total}} حسب قيمة المخزون؛ ويتضمن الملف المنزَّل جميع المتغيرات.',
    empty: 'لا توجد منتجات في المخزون.',
  },
  purchasing: {
    navSuppliers: 'المورّدون',
    navOrders: 'المشتريات',
    navReceive: 'استلام البضائع',
    statuses: {
      requested: 'طلب شراء',
      ordered: 'تم الطلب',
      partially_received: 'مستلم جزئيًا',
      received: 'مستلم بالكامل',
      closed: 'مغلق',
      cancelled: 'ملغى',
    },
    filters: { all: 'جميع الطلبات', open: 'الطلبات المفتوحة' },
    supplier: 'المورّد',
    supplierStatus: { active: 'نشط', inactive: 'غير نشط' },
    addSupplier: 'إضافة مورّد',
    editSupplier: 'تعديل المورّد',
    saveSupplier: 'حفظ المورّد',
    supplierSaved: 'تم حفظ المورّد.',
    fields: {
      name: 'الاسم القانوني',
      code: 'الرمز',
      taxOffice: 'مكتب الضرائب',
      taxNumber: 'الرقم الضريبي / رقم الهوية',
      contactName: 'مسؤول التواصل',
      email: 'البريد الإلكتروني',
      phone: 'الهاتف',
      address: 'العنوان',
      currency: 'العملة',
      paymentTermDays: 'مدة السداد (بالأيام)',
      leadTimeDays: 'مدة التوريد (بالأيام)',
      note: 'ملاحظة',
      status: 'الحالة',
    },
    supplierCols: {
      supplier: 'المورّد',
      contact: 'التواصل',
      terms: 'مدة السداد',
      balance: 'الرصيد',
      overdue: 'متأخر السداد',
      status: 'الحالة',
    },
    noSuppliers: 'لا يوجد مورّدون بعد',
    noSuppliersLead: 'أضف الشركات التي تشتري منها؛ ترتبط أوامر الشراء وحساب المورّد بمورّد محدد.',
    termsDays: '{{days}} يومًا',
    cash: 'نقدًا',
    performanceTitle: 'أداء المورّدين',
    performanceLead:
      'يعتمد على الطلبات المُرسلة إلى المورّدين خلال الفترة؛ وتُحسب قيمة المشتريات من البضائع المستلمة خلال الفترة (دون ضريبة القيمة المضافة).',
    perfCols: {
      supplier: 'المورّد',
      orders: 'الطلبات',
      onTime: 'التسليم في الموعد',
      fill: 'نسبة التلبية',
      short: 'بنود ناقصة',
      over: 'بنود زائدة',
      lead: 'متوسط مدة التوريد',
      spend: 'قيمة المشتريات',
    },
    late: 'متأخر: {{count}}',
    ledgerTitle: 'الحساب الجاري',
    ledgerLead:
      'المبالغ الموجبة مستحقة للمورّد، والسالبة دفعات أو مبالغ دائنة. تُقيَّد فواتير استلام البضائع تلقائيًا.',
    addEntry: 'إضافة قيد في الحساب',
    saveEntry: 'حفظ القيد',
    entrySaved: 'تمت إضافة القيد في الحساب.',
    reverse: 'عكس القيد',
    reverseTitle: 'التصحيح بقيد عكسي',
    reverseReason: 'السبب',
    reverseSave: 'إنشاء القيد العكسي',
    reversed: 'تم إنشاء القيد العكسي.',
    kinds: {
      opening: 'رصيد افتتاحي',
      invoice: 'فاتورة (استلام البضائع)',
      payment: 'دفعة',
      return: 'مرتجع / مبلغ دائن',
      adjustment: 'قيد تسوية',
      reversal: 'قيد عكسي',
    },
    directions: { debit: 'زيادة الدين', credit: 'تخفيض الدين' },
    methods: {
      bank_transfer: 'تحويل بنكي',
      cash: 'نقدًا',
      cheque: 'شيك',
      note: 'سند لأمر',
      card: 'بطاقة',
      other: 'أخرى',
    },
    entryFields: {
      kind: 'نوع القيد',
      amount: 'المبلغ',
      direction: 'الاتجاه',
      date: 'التاريخ',
      dueDate: 'تاريخ الاستحقاق',
      method: 'طريقة الدفع',
      reference: 'رقم الإيصال / المستند',
      description: 'الوصف',
    },
    ledgerCols: {
      date: 'التاريخ',
      kind: 'القيد',
      description: 'الوصف',
      due: 'الاستحقاق',
      amount: 'المبلغ',
      balance: 'الرصيد',
    },
    noEntries: 'لا توجد قيود في الحساب.',
    balanceLine: 'الرصيد: {{amount}} · متأخر السداد: {{overdue}}',
    reversedMark: 'معكوس',
    ordersOfSupplier: 'طلبات هذا المورّد',
    newOrder: 'طلب شراء جديد',
    noOrders: 'لا توجد أوامر شراء',
    noOrdersLead:
      'أنشئ طلب شراء؛ يؤدي زر «إرسال الطلب» إلى اعتباره مُرسلًا إلى المورّد، ويُسجَّل استلام البضائع عند وصولها.',
    orderCols: {
      number: 'الرقم',
      supplier: 'المورّد',
      warehouse: 'المستودع',
      expected: 'المتوقع',
      status: 'الحالة',
      progress: 'المستلم',
      total: 'الإجمالي (شامل ضريبة القيمة المضافة)',
    },
    progress: '{{received}} / {{ordered}}',
    warehouse: 'مستودع الاستلام',
    expectedDate: 'تاريخ التسليم المتوقع',
    note: 'ملاحظة',
    linesTitle: 'المنتجات',
    addProduct: 'إضافة منتج',
    lineCols: {
      product: 'المنتج',
      quantity: 'الكمية',
      received: 'المستلم',
      remaining: 'المتبقي',
      unitCost: 'تكلفة الوحدة (دون ضريبة القيمة المضافة)',
      tax: 'ضريبة القيمة المضافة %',
      total: 'المبلغ (دون ضريبة القيمة المضافة)',
    },
    taxDefault: 'نسبة ضريبة القيمة المضافة للمنتج',
    removeLine: 'إزالة البند',
    totals: {
      subtotal: 'المجموع الفرعي (دون ضريبة القيمة المضافة)',
      tax: 'ضريبة القيمة المضافة',
      total: 'الإجمالي (شامل ضريبة القيمة المضافة)',
    },
    createOrder: 'إنشاء طلب الشراء',
    saveOrder: 'حفظ طلب الشراء',
    orderCreated: 'تم إنشاء طلب الشراء.',
    orderSaved: 'تم الحفظ.',
    editLines: 'تعديل طلب الشراء',
    placeOrder: 'إرسال الطلب',
    placeConfirm:
      'سيُعتبر طلب الشراء طلبًا مُرسلًا إلى المورّد، ولن يمكن بعد ذلك تغيير البنود. هل تريد المتابعة؟',
    placed: 'تم تعليم الطلب كمُرسل.',
    cancelOrder: 'إلغاء الطلب',
    cancelConfirm: 'سيتم إلغاء الطلب. لا يمكن إلغاء إلا الطلبات التي لم يُستلم منها أي شيء.',
    cancelled: 'تم إلغاء الطلب.',
    closeOrder: 'إغلاق الطلب',
    closeConfirm: 'لن تُنتظر الكميات المتبقية؛ سيتم إغلاق الطلب.',
    closed: 'تم إغلاق الطلب.',
    print: 'طباعة',
    orderInfo: 'تفاصيل الطلب',
    requestedOn: 'تاريخ إنشاء الطلب',
    orderedOn: 'تاريخ إرسال الطلب',
    noExpected: 'غير محدد',
    changeDate: 'تغيير التاريخ',
    saveDate: 'حفظ التاريخ',
    receiptsTitle: 'عمليات استلام البضائع',
    noReceipts: 'لم تُستلم أي بضائع بعد.',
    receiptLine: '{{number}} · {{date}} · البنود: {{count}}',
    invoiceNo: 'رقم الفاتورة / إشعار التسليم',
    lot: 'الدفعة {{lot}}',
    expiry: 'انتهاء الصلاحية {{date}}',
    pickSupplier: 'اختر مورّدًا',
    pickWarehouse: 'اختر مستودعًا',
    quantityInvalid: 'يجب أن تكون الكمية عددًا صحيحًا يساوي 1 أو أكثر.',
    costInvalid: 'تعذّرت قراءة المبلغ (مثل 120.50).',
    receiveTitle: 'استلام البضائع: {{number}}',
    receive: 'استلام البضائع',
    receiveSave: 'حفظ الاستلام',
    received: 'تم حفظ الاستلام وتحديث المخزون.',
    receiveLead:
      'أدخل الكميات الواصلة، واترك البنود غير الواصلة عند 0. للمنتجات المتتبَّعة بالدفعات أدخل رقم الدفعة وتاريخ انتهاء الصلاحية.',
    receivedOn: 'تاريخ الاستلام',
    receiveCols: {
      product: 'المنتج',
      remaining: 'المتبقي',
      quantity: 'الكمية المستلمة',
      lot: 'رقم الدفعة',
      expiry: 'تاريخ انتهاء الصلاحية',
      cost: 'تكلفة الوحدة في الفاتورة',
    },
    acceptOver: 'قبول كمية تتجاوز الكمية المتبقية (تسليم زائد)',
    postInvoice: 'قيد الفاتورة في حساب المورّد (شاملة ضريبة القيمة المضافة، مع مدة السداد)',
    updateCost: 'تحديث تكلفة المنتج (متوسط التكلفة المرجّح المتحرك)',
    nothingToReceive: 'أدخل كمية في بند واحد على الأقل.',
    receivableEmpty: 'لا توجد طلبات بانتظار الاستلام',
    receivableLead: 'الطلبات المُرسلة إلى المورّدين والتي لم تُستلم بالكامل. لا تُعرض التكاليف هنا.',
    receivableCols: {
      number: 'الطلب',
      supplier: 'المورّد',
      warehouse: 'المستودع',
      expected: 'المتوقع',
      lines: 'المتبقي',
    },
    remainingLines: 'البنود: {{count}} · الوحدات: {{units}}',
    overdueMark: 'متأخر',
    costUpdated: 'منتجات حُدّثت تكلفتها: {{count}}',
  },
  reportBuilder: {
    navLabel: 'منشئ التقارير',
    datasets: { orders: 'الطلبات', lines: 'مبيعات المنتجات', stock: 'المخزون (اليوم)' },
    datasetLeads: {
      orders: 'الطلبات المحتسبة كما في تقرير المبيعات؛ المبالغ بالليرة التركية (TRY) حسب تاريخ الطلب.',
      lines:
        'بنود الطلبات المحتسبة؛ دون ضريبة القيمة المضافة، وتُخصم المبالغ المستردة بالتناسب؛ وتكلفة البضاعة المباعة بتكلفة لحظة البيع.',
      stock: 'رصيد المخزون الحالي؛ القيمة بالتكلفة الحالية.',
    },
    metrics: {
      orders: 'الطلبات',
      cancelledOrders: 'الطلبات الملغاة',
      grossSales: 'قيمة الطلبات',
      deductions: 'المرتجعات والإلغاءات',
      netSales: 'صافي المبيعات',
      netSalesExVat: 'صافي المبيعات (دون ضريبة القيمة المضافة)',
      shipping: 'الشحن',
      items: 'الوحدات المباعة',
      newCustomers: 'العملاء الجدد',
      averageOrder: 'متوسط قيمة الطلب',
      quantity: 'الكمية',
      cogs: 'تكلفة البضاعة المباعة',
      grossProfit: 'إجمالي الربح',
      unknownCostSales: 'مبيعات بتكلفة غير معروفة',
      marginBps: 'هامش الربح الإجمالي',
      onHand: 'المتوفر',
      reserved: 'محجوز',
      available: 'القابل للبيع',
      stockValue: 'قيمة المخزون',
      unknownCostUnits: 'وحدات بدون تكلفة',
    },
    dims: {
      day: 'اليوم',
      week: 'الأسبوع',
      month: 'الشهر',
      year: 'السنة',
      store: 'المتجر',
      channel: 'القناة',
      segment: 'نوع العميل',
      paymentMethod: 'طريقة الدفع',
      country: 'الدولة',
      city: 'المدينة',
      customerType: 'جديد / عائد',
      product: 'المنتج',
      variant: 'SKU',
      category: 'الفئة',
      brand: 'العلامة التجارية',
      warehouse: 'المستودع',
      expiryMonth: 'شهر انتهاء الصلاحية',
    },
    customerTypes: { new: 'عميل جديد', returning: 'عميل عائد' },
    dataset: 'مجموعة البيانات',
    metricsLabel: 'المؤشرات (حتى 4)',
    row1: 'بُعد الصفوف',
    row2: 'بُعد الصفوف الثاني',
    column: 'بُعد الأعمدة (جدول محوري)',
    none: 'لا شيء',
    filtersTitle: 'المرشّحات',
    warehouse: 'المستودع',
    category: 'الفئة',
    brand: 'العلامة التجارية',
    all: 'الكل',
    sort: 'الترتيب',
    sortAuto: 'تلقائي',
    sortDesc: '{{metric}} (من الأعلى إلى الأدنى)',
    sortAsc: '{{metric}} (من الأدنى إلى الأعلى)',
    limit: 'الحد الأقصى للصفوف',
    run: 'تشغيل',
    resultTitle: 'النتيجة',
    total: 'الإجمالي',
    empty: 'لا توجد بيانات لهذا الاختيار.',
    hidden: 'فارغ لأنك لا تملك صلاحية رؤية التكاليف: {{names}}',
    multiValued:
      'تُحتسب المنتجات المدرجة في عدة فئات ضمن كل فئة منها؛ وقد يتجاوز مجموع الصفوف الإجمالي العام.',
    truncatedRows:
      'يتم عرض أول {{shown}} صف من أصل {{total}}؛ ويحتوي الملف على الصفوف نفسها. يمكنك رفع الحد.',
    truncatedColumns: 'يتم عرض أول 36 عمودًا.',
    fxMissing: 'تم استبعاد {{count}} من السجلات التي لا يتوفر لها سعر صرف.',
    pivotOneMetric: 'عند اختيار بُعد للأعمدة يُعرض المؤشر الأول فقط.',
    chartTitle: '{{metric}} — {{dim}}',
    savedTitle: 'التقارير المحفوظة',
    savedEmpty: 'لا توجد تقارير محفوظة.',
    sharedBy: 'شاركه: {{name}}',
    mine: 'تقاريري',
    sharedMark: 'مشترك',
    open: 'فتح',
    current: 'التقرير المفتوح: {{name}}',
    newReport: 'تقرير جديد',
    save: 'حفظ التقرير',
    saveChanges: 'حفظ التغييرات',
    saveAs: 'حفظ كتقرير جديد',
    saveTitle: 'حفظ التقرير',
    name: 'اسم التقرير',
    description: 'الوصف',
    visibility: 'مستوى الظهور',
    visibilities: { private: 'أنا فقط', shared: 'مشترك' },
    shareRoles: 'المشاركة مع الأدوار',
    shareUsers: 'المشاركة مع أشخاص',
    shareNote:
      'يرى الأشخاص الذين تشارك التقرير معهم البيانات وفق صلاحياتهم الخاصة: يُطبَّق نطاق المتجر وصلاحية رؤية التكاليف.',
    saved: 'تم حفظ التقرير.',
    deleteReport: 'حذف التقرير',
    deleteConfirm: 'سيُحذف التقرير المحفوظ، ولن يتمكن الأشخاص الذين شورك معهم من رؤيته بعد ذلك.',
    deleted: 'تم حذف التقرير.',
    readOnly: 'تمت مشاركة هذا التقرير معك؛ يمكنك حفظ التغييرات كتقرير جديد.',
    background: 'الإعداد في الخلفية',
    backgroundQueued: 'يجري إعداد الملف؛ يمكنك تنزيله من «ملفات تقاريري».',
    openFiles: 'ملفات تقاريري',
    schedule: 'جدولة',
  },
  reportWidgets: {
    title: 'عناصر تقاريري',
    empty:
      'لا توجد لديك عناصر تقارير. افتح في منشئ التقارير تقريرًا حفظته أو تقريرًا مشتركًا معك، ثم استخدم «إضافة إلى لوحة المعلومات».',
    goBuilder: 'الانتقال إلى منشئ التقارير',
    addToDashboard: 'إضافة إلى لوحة المعلومات',
    added: 'أُضيف التقرير إلى لوحة المعلومات.',
    onDashboard: 'في لوحة المعلومات',
    display: 'طريقة العرض',
    size: 'عرض العنصر',
    displays: { table: 'جدول', chart: 'رسم بياني', number: 'الإجمالي فقط' },
    sizes: { half: 'نصف العرض', full: 'العرض الكامل' },
    moveUp: 'نقل للأعلى: {{name}}',
    moveDown: 'نقل للأسفل: {{name}}',
    remove: 'إزالة: {{name}}',
    removed: 'أُزيل العنصر.',
    unavailable: 'لم يعد هذا التقرير مشتركًا معك أو تم حذفه.',
    unavailableTitle: 'تقرير غير متاح',
    openReport: 'فتح التقرير',
    moreRows: 'صفوف إضافية في التقرير: {{count}}',
    chartUnavailable: 'يتطلب الرسم البياني بُعد صفوف واحدًا دون بُعد للأعمدة؛ يُعرض الجدول بدلًا منه.',
    settings: 'إعدادات العنصر: {{name}}',
  },
  reportFiles: {
    navLabel: 'ملفات تقاريري',
    filesTitle: 'ملفاتي',
    filesEmpty:
      'لا توجد ملفات بعد. استخدم «التحضير في الخلفية» في منشئ التقارير لطلب تقرير كبير، أو أعدّ تقريرًا مجدولًا.',
    name: 'التقرير',
    format: 'الصيغة',
    status: 'الحالة',
    rows: 'الصفوف',
    size: 'الحجم',
    created: 'تاريخ الطلب',
    expires: 'تاريخ الحذف',
    source: 'المصدر',
    sources: { manual: 'طلب يدوي', schedule: 'مجدول', workflow: 'مسار الأتمتة' },
    statuses: { queued: 'في قائمة الانتظار', running: 'قيد التحضير', done: 'جاهز', failed: 'تعذّر التحضير' },
    download: 'تنزيل',
    downloadNamed: 'تنزيل: {{name}}',
    failedGeneric: 'تعذّر إنشاء الملف؛ اطلبه مرة أخرى.',
    keepNote: 'تُنشأ الملفات بصلاحياتك، ولا تظهر إلا لك، وتُحذف بعد 30 يومًا. الحد الأقصى 50,000 صف.',
    kb: '{{n}} كيلوبايت',
    schedulesTitle: 'التقارير المجدولة',
    schedulesEmpty: 'لا توجد تقارير مجدولة.',
    newSchedule: 'جدولة جديدة',
    report: 'التقرير المحفوظ',
    pickReport: 'اختر تقريرًا',
    noSavedReports: 'احفظ تقريرًا في منشئ التقارير أولًا.',
    frequency: 'التكرار',
    frequencies: { daily: 'يومي', weekly: 'أسبوعي', monthly: 'شهري' },
    weekday: 'اليوم',
    weekdays: {
      '1': 'الاثنين',
      '2': 'الثلاثاء',
      '3': 'الأربعاء',
      '4': 'الخميس',
      '5': 'الجمعة',
      '6': 'السبت',
      '7': 'الأحد',
    },
    weekdaysInline: {
      '1': 'يوم اثنين',
      '2': 'يوم ثلاثاء',
      '3': 'يوم أربعاء',
      '4': 'يوم خميس',
      '5': 'يوم جمعة',
      '6': 'يوم سبت',
      '7': 'يوم أحد',
    },
    monthDay: 'يوم الشهر',
    hour: 'الساعة (توقيت تركيا)',
    when: {
      daily: 'كل يوم الساعة {{hour}}',
      weekly: 'كل {{day}} الساعة {{hour}}',
      monthly: 'اليوم {{day}} من كل شهر الساعة {{hour}}',
    },
    periodNote: {
      daily: 'يُرسل تقرير اليوم السابق.',
      weekly: 'يُرسل تقرير الأسبوع السابق (من الاثنين إلى الأحد).',
      monthly: 'يُرسل تقرير الشهر السابق.',
    },
    recipients: 'المستلمون',
    recipientCount: 'عدد المستلمين: {{count}}',
    enabled: 'الإرسال مفعّل',
    enabledNamed: 'الإرسال: {{name}}',
    on: 'مفعّل',
    off: 'متوقف',
    nextRun: 'الإرسال التالي',
    lastDelivery: 'آخر إرسال',
    never: 'لم يتم بعد',
    deliveryStatuses: {
      running: 'جارٍ الإرسال',
      sent: 'تم الإرسال',
      partial: 'جزئي',
      failed: 'تعذّر الإرسال',
    },
    deliveryCounts: 'تم الإرسال: {{sent}} · تم التخطي: {{skipped}}',
    edit: 'تعديل',
    editNamed: 'تعديل: {{name}}',
    deleteNamed: 'حذف: {{name}}',
    deleteConfirm: 'ستُحذف الجدولة. تبقى الملفات التي أُنشئت سابقًا حتى انتهاء صلاحيتها.',
    deleted: 'حُذفت الجدولة.',
    saved: 'حُفظت الجدولة.',
    dialogNew: 'جدولة التقرير',
    dialogEdit: 'تعديل الجدولة',
    deliveryNote:
      'لا يحتوي البريد الإلكتروني على بيانات التقرير، بل على رابط هذه الصفحة فقط. يُنشأ ملف كل مستلم بصلاحياته الخاصة؛ ويُتخطّى المستلم الذي لا يستطيع رؤية التقرير. تبقى الجدولة الجديدة متوقفة إلى أن تفعّل الإرسال.',
    unknownReport: 'تقرير غير متاح',
  },
  disputes: {
    navLabel: 'اعتراضات الدفع',
    newDispute: 'اعتراض جديد',
    statusFilter: 'الحالة',
    filters: { active: 'المفتوحة', closed: 'المغلقة', all: 'الكل' },
    empty: 'لا توجد اعتراضات دفع مسجّلة.',
    emptyActive: 'لا توجد اعتراضات دفع مفتوحة.',
    tableTitle: 'اعتراضات الدفع',
    cols: {
      number: 'رقم الاعتراض',
      order: 'الطلب',
      kind: 'النوع',
      status: 'الحالة',
      amount: 'المبلغ',
      fee: 'الرسوم',
      opened: 'تاريخ الفتح',
      due: 'آخر موعد للرد',
      closed: 'تاريخ الإغلاق',
    },
    kinds: { chargeback: 'رد المبلغ المدفوع (Chargeback)', inquiry: 'طلب معلومات/مستندات' },
    statuses: {
      open: 'مفتوح',
      evidence_submitted: 'تم تقديم المستندات',
      won: 'مكسوب',
      lost: 'خاسر',
      accepted: 'مقبول',
    },
    providers: { iyzico: 'iyzico', paytr: 'PayTR', manual: 'جهاز نقاط بيع فعلي / يدوي' },
    overdue: 'انقضت المهلة',
    dueSoon: 'المهلة على وشك الانتهاء',
    summary: 'عدد الاعتراضات المفتوحة: {{count}}. يظهر المبلغ المعرّض للخطر في التقرير المالي.',
    dialogTitle: 'فتح اعتراض دفع',
    orderNumber: 'رقم الطلب',
    findPayments: 'البحث عن الدفعات',
    noPayments:
      'لا يحتوي هذا الطلب على دفعة يمكن فتح اعتراض عليها. لا تنطبق الاعتراضات إلا على الدفعات بالبطاقة أو عبر جهاز نقاط بيع فعلي.',
    payment: 'الدفعة',
    paymentOption: '{{provider}} · {{amount}} · {{date}}',
    alreadyDisputed: 'المبلغ قيد الاعتراض: {{amount}}',
    kind: 'النوع',
    caseNumber: 'الرقم المرجعي لدى البنك/المزوّد',
    reasonCode: 'رمز السبب',
    reason: 'السبب',
    amount: 'المبلغ المعترض عليه',
    fee: 'رسوم الاعتراض',
    openedOn: 'تاريخ الإشعار',
    responseDueOn: 'آخر موعد للرد',
    note: 'ملاحظة',
    amountInvalid: 'تعذّرت قراءة المبلغ.',
    created: 'سُجّل الاعتراض.',
    saved: 'حُدّث الاعتراض.',
    providerNote:
      'يُحفظ السجل في لوحة التحكم؛ ولا يُرسل أي شيء إلى البنك أو مزوّد الدفع. قدّم ردك ومستنداتك في لوحة التحكم الخاصة بالمزوّد.',
    detailTitle: 'الاعتراض {{number}}',
    back: 'اعتراضات الدفع',
    infoTitle: 'التفاصيل',
    order: 'الطلب',
    paymentInfo: 'الدفعة',
    paymentLine: '{{provider}} · {{amount}}',
    refunded: 'المبلغ المسترد: {{amount}}',
    actionsTitle: 'الحالة',
    moveTo: {
      evidence_submitted: 'وضع علامة «تم تقديم المستندات»',
      won: 'مكسوب',
      lost: 'خاسر',
      accepted: 'قبول (دون اعتراض)',
      open: 'إعادة الفتح',
    },
    statusDialog: 'تغيير الحالة: {{status}}',
    closedOn: 'تاريخ الإغلاق',
    statusNote: 'تعليق',
    reopenNote: 'يلزم ذكر سبب لإعادة الفتح (مثل التحكيم).',
    lossNote:
      'يُخصم المبلغ الخاسر أو المقبول في التقرير المالي من الربح (في فترة الطلب) ومن النقد (في تاريخ الإغلاق).',
    statusChanged: 'تغيّرت الحالة.',
    edit: 'تصحيح',
    editTitle: 'تصحيح الاعتراض',
    documentsTitle: 'المستندات',
    noDocuments: 'لم تُضف أي مستندات.',
    upload: 'إضافة مستند',
    uploadHint: 'PDF أو JPEG أو PNG؛ بحد أقصى 10 ميغابايت. لا تظهر المستندات إلا في لوحة التحكم.',
    uploaded: 'أُضيف المستند.',
    downloadNamed: 'تنزيل: {{name}}',
    notesTitle: 'إضافة ملاحظة',
    addNote: 'إضافة الملاحظة',
    noteAdded: 'أُضيفت الملاحظة.',
    historyTitle: 'السجل',
    events: {
      created: 'سُجّل الاعتراض',
      status: 'الحالة: {{from}} ← {{to}}',
      updated: 'صُحّحت التفاصيل',
      note: 'ملاحظة',
      document: 'أُضيف مستند: {{name}}',
    },
    by: '{{name}}',
    system: 'النظام',
  },
  priceSimulation: {
    navLabel: 'محاكاة الأسعار',
    priceList: 'قائمة الأسعار (TRY)',
    category: 'الفئة',
    brand: 'العلامة التجارية',
    days: 'فترة حجم المبيعات',
    lastDays: 'آخر {{count}} يومًا',
    priceChange: 'تغيير السعر (%)',
    costChange: 'تغيير التكلفة (%)',
    feeRate: 'نسبة الرسوم (%)',
    feeDefault: 'إذا تُرك فارغًا: المعدّل الفعلي للفترة',
    minMargin: 'الحد الأدنى للهامش (%)',
    percentInvalid: 'تعذّرت قراءة النسبة المئوية (مثل 10، -5، 2.5).',
    run: 'حساب',
    noWrite: 'لا تتغير الأسعار؛ يتم الحساب فقط.',
    noLists: 'لا توجد قوائم أسعار بعملة TRY.',
    summary: 'ملخص المحاكاة',
    currentContribution: 'هامش المساهمة للفترة (الحالي)',
    scenarioContribution: 'هامش المساهمة للفترة (السيناريو)',
    periodOf: 'بحجم مبيعات الفترة {{from}} – {{to}}',
    changeOf: 'الفرق: {{amount}}',
    feeUsed: 'الرسوم في السيناريو',
    feeCurrent: 'المعدّل الفعلي للفترة: {{pct}} (عدد الدفعات: {{count}})',
    feeNone: 'لا توجد دفعات في الفترة؛ اعتُبر المعدّل الفعلي 0%.',
    warnings: 'منتجات عليها تنبيه',
    warningsOf: 'بخسارة: {{negative}} · دون الحد الأدنى للهامش: {{low}}',
    assumption:
      'هامش المساهمة = السعر دون ضريبة القيمة المضافة − التكلفة − الرسوم. يُفترض أن حجم المبيعات لا يتغير بتغيّر السعر؛ ولا تُوزَّع تكاليف الشحن والإعلانات على الوحدة.',
    noCost: 'لم تُحتسب المنتجات التي لا تكلفة مسجّلة لها (العدد: {{count}}).',
    feeUnknown: 'لا توجد قاعدة رسوم لـ {{count}} من الدفعات بالبطاقة؛ قد يكون المعدّل الفعلي أقل من حقيقته.',
    unitsHidden: 'يتطلب حجم المبيعات صلاحية تقرير المبيعات؛ لم يُحسب أثر الفترة.',
    truncated: 'يُعرض أول {{count}} من المنتجات (ذات التنبيه أولًا).',
    tableTitle: 'اقتصاديات الوحدة حسب المنتج (الحالي ← السيناريو)',
    empty: 'لا توجد منتجات لها سعر وتكلفة تطابق الاختيار.',
    cols: {
      product: 'المنتج',
      units: 'الوحدات المباعة',
      price: 'السعر',
      net: 'دون ضريبة القيمة المضافة',
      cost: 'التكلفة',
      fee: 'الرسوم',
      contribution: 'مساهمة الوحدة',
      margin: 'الهامش',
    },
    loss: 'خسارة',
    low: 'هامش منخفض',
    goBulk: 'الانتقال إلى تغيير الأسعار بالجملة لتطبيق الأسعار',
  },
  marketingSummary: {
    navLabel: 'ملخص التسويق وSEO',
    funnelTitle: 'مسار التحويل في واجهة المتجر (سجلات الخادم)',
    funnel: { carts: 'الإضافة إلى سلة التسوق', checkouts: 'خطوة إتمام الطلب', orders: 'الطلبات المؤكدة' },
    stepRate: 'من الخطوة السابقة: {{pct}}',
    funnelOverall: 'من سلة التسوق إلى الطلب المؤكد: {{pct}}.',
    funnelNote:
      'لا تُحفظ مشاهدات المنتجات على الخادم (فهي في GA4، بموافقة الزائر على ملفات تعريف الارتباط). تشمل خطوة إتمام الطلب الدفعات المعلّقة والفاشلة. قد يفتح الزائر الواحد عدة سلال تسوق.',
    customersTitle: 'اكتساب العملاء وقيمتهم',
    newCustomers: 'العملاء الجدد',
    returning: 'العائدون: {{count}}',
    cac: 'تكلفة الإعلان لكل عميل جديد (CAC)',
    cacOf: 'الإنفاق الإعلاني: {{spend}}',
    cacHidden: 'بيانات الإعلانات على مستوى المنشأة؛ لا تُعرض عند تصفية المتجر أو دون صلاحية الإعلانات.',
    noAds: 'لا يوجد حساب إعلاني مرتبط.',
    value12m: 'قيمة العميل خلال 12 شهرًا',
    value12mOf: 'العملاء في آخر 12 شهرًا: {{customers}} · الطلبات لكل عميل: {{orders}}',
    valueToCac: 'قيمة العميل ÷ CAC',
    valueToCacNote: 'قيمة تاريخية لمدة 12 شهرًا؛ وليست توقعًا.',
    adsTitle: 'الإعلانات',
    adSpend: 'الإنفاق',
    clicks: 'النقرات',
    ctr: 'نسبة النقر إلى الظهور',
    cpc: 'تكلفة النقرة',
    openAds: 'فتح مركز الإعلانات',
    seoTitle: 'البحث العضوي (Search Console)',
    seoNotLinked: 'Search Console غير مرتبط.',
    organicClicks: 'النقرات العضوية',
    impressions: 'مرات الظهور',
    position: 'متوسط الترتيب',
    seoLast: 'آخر يوم للبيانات: {{date}} (تتأخر بيانات Search Console بمقدار 2–3 أيام).',
    seoNoData: 'لا توجد بيانات مُزامَنة لهذه الفترة.',
    messagingTitle: 'حملات البريد الإلكتروني والرسائل',
    channel: 'القناة',
    sent: 'المُرسَلة',
    delivered: 'المُسلَّمة',
    clicked: 'من نقروا',
    email: 'البريد الإلكتروني',
    channels: { sms: 'SMS', whatsapp: 'WhatsApp' },
    sourcesTitle: 'مصدر آخر نقطة تواصل للطلبات (واجهة المتجر)',
    sourcesEmpty: 'لا توجد طلبات من واجهة المتجر في هذه الفترة.',
    source: 'المصدر / الوسيط',
    orders: 'الطلبات',
    share: 'الحصة',
    sourceKinds: {
      direct: 'مباشر / غير معروف',
      no_consent: 'لا توجد موافقة على ملفات تعريف الارتباط (المصدر غير معروف)',
    },
    openAttribution: 'فتح تقرير المصادر',
    fxMissing:
      'لم تُحتسب في أرقام المبيعات {{count}} من الطلبات بالعملات الأجنبية التي لا يتوفر لها سعر صرف.',
  },
  multiTouch: {
    navLabel: 'إسناد المصدر متعدد نقاط التواصل',
    dimension: 'التقسيم',
    dimensions: { source_medium: 'المصدر / الوسيط', campaign: 'الحملة' },
    summary: 'ملخص إسناد المصدر',
    orders: 'الطلبات المؤكدة من واجهة المتجر',
    attributed: 'طلبات معروفة المصدر',
    attributedOf: 'مع الموافقة على ملفات تعريف الارتباط ونقطة تواصل واحدة على الأقل',
    withPath: 'طلبات لها نقاط تواصل وسيطة',
    withPathOf: 'تُسجَّل نقاط التواصل الوسيطة منذ تفعيل هذه الميزة',
    avgTouches: 'متوسط نقاط التواصل لكل طلب',
    tableTitle: 'حصة الطلبات وصافي المبيعات حسب النموذج',
    models: { first: 'أول نقطة تواصل', last: 'آخر نقطة تواصل', linear: 'خطي', position: 'حسب الموضع (U)' },
    orderShare: 'الطلبات',
    revenue: 'صافي المبيعات',
    kinds: {
      direct: 'مباشر / بلا نقطة تواصل',
      no_consent: 'لا توجد موافقة على ملفات تعريف الارتباط (المصدر غير معروف)',
    },
    noCampaign: 'بلا حملة',
    empty: 'لا توجد طلبات مؤكدة من واجهة المتجر في هذه الفترة.',
    note: 'الخطي: حصة متساوية لكل نقطة تواصل. حسب الموضع (U): 40% لكلٍّ من أول وآخر نقطة تواصل، و20% إجمالًا لنقاط التواصل الوسيطة (50/50 عند وجود نقطتي تواصل فقط). تُوزَّع حصص الطلبات وصافي المبيعات (شاملًا ضريبة القيمة المضافة، بعد خصم المبالغ المستردة والإلغاءات) دون باقٍ.',
    pathNote:
      'تُعدّ الزيارات المتتالية من المصدر نفسه نقطة تواصل واحدة؛ ويُحتفظ بما يصل إلى 5 نقاط تواصل وسيطة. لا توجد نقاط تواصل وسيطة إلا للطلبات المقدّمة بعد تفعيل هذه الميزة؛ أما الطلبات السابقة فيعتمد فيها النموذج الخطي ونموذج U على أول وآخر نقطة تواصل فقط.',
    fxMissing: 'لم تُحتسب {{count}} من الطلبات بالعملات الأجنبية التي لا يتوفر لها سعر صرف.',
  },
  workflows: {
    navLabel: 'مسارات الأتمتة',
    lead: 'مسارات تعمل تلقائيًا عند وقوع حدث ما (منتج جديد، طلب مدفوع، مخزون حرج، نهاية فترة…): تتحقق من الشروط وتنفّذ الإجراءات. يعالج المسار الأحداث التي تقع بعد تشغيله؛ وتُنفَّذ الإجراءات بالصلاحيات الحالية للشخص الذي شغّله، وتُسجَّل كل خطوة. أما الرسائل الموجّهة إلى العملاء (تذكيرات السلة، إشعارات عودة المخزون) فتبقى في أقسامها الخاصة مع التحقق من الموافقة ومن İYS.',
    newFlow: 'مسار جديد',
    newFlowName: 'مسار جديد',
    pauseAll: 'إيقاف الكل مؤقتًا',
    pauseAllConfirm:
      'سيتم إيقاف جميع المسارات المشغّلة مؤقتًا وإلغاء عمليات التنفيذ قيد الانتظار. هل تريد المتابعة؟',
    pausedAll: 'المسارات الموقوفة مؤقتًا: {{count}}.',
    autoPausedAlert: 'مسارات توقفت تلقائيًا ({{count}})؛ عالج السبب ثم شغّلها مجددًا:',
    flowsTitle: 'المسارات',
    summaryLine:
      'المسارات قيد التشغيل: {{active}} من {{total}} · عمليات التنفيذ الفاشلة في آخر 7 أيام: {{failed}}',
    flowsEmpty: 'لا توجد مسارات بعد. ابدأ بأحد الأمثلة الجاهزة أدناه.',
    columns: {
      name: 'المسار',
      chain: 'المشغّل ← الإجراءات',
      status: 'الحالة',
      runs: 'آخر 7 أيام',
      last: 'آخر تنفيذ',
    },
    runAsShort: 'شغّله: {{name}}',
    runsCounts: '{{succeeded}} ناجح · {{failed}} فاشل · {{pending}} قيد الانتظار',
    never: 'لم يُنفَّذ بعد',
    next: 'التنفيذ التالي: {{date}}',
    statuses: { draft: 'مسودة', active: 'قيد التشغيل', paused: 'متوقف مؤقتًا', archived: 'مؤرشف' },
    pausedReasons: {
      manual: 'أُوقف يدويًا.',
      rate_limited: 'توقف تلقائيًا لتجاوز الحد الأقصى لعدد عمليات التنفيذ في الساعة.',
      owner_inactive: 'توقف تلقائيًا لأن عضوية الشخص الذي شغّله أُغلقت.',
      owner_permission: 'توقف تلقائيًا لأن الشخص الذي شغّله يفتقر إلى صلاحية لازمة.',
    },
    templatesTitle: 'أمثلة جاهزة',
    useTemplate: 'البدء بهذا المثال',
    useTemplateNamed: 'البدء بالمثال «{{name}}»',
    linked: 'رسالة إلى العملاء — في قسمها الخاص',
    linkedOn: 'مُفعّل',
    linkedOff: 'متوقف',
    openLinked: 'الانتقال إلى الإعدادات',
    templates: {
      new_product_seo_merchant: {
        name: 'منتج جديد ← فحص SEO ← Merchant Center',
        text: 'عند إضافة منتج يتحقق من قواعد SEO (العنوان، الوصف، الصورة، الباركود)؛ فإذا لم توجد مشكلات يزامن منتجات المتجر مع Merchant Center، وإلا يتوقف ويسجّل المشكلات.',
      },
      price_change_feed_log: {
        name: 'تغيّر السعر ← تحديث الخلاصة (Feed) ← سجل التغيير',
        text: 'عند تغيّر السعر يزامن منتجات المتجر مع Merchant Center ويسجّل الحدث في سجل التدقيق. عند تكرار التغييرات يعمل مرة كل 15 دقيقة على الأكثر.',
      },
      critical_stock_notify: {
        name: 'مخزون حرج ← إشعار المدير',
        text: 'يرسل بريدًا إلكترونيًا إلى أعضاء الفريق الذين لديهم صلاحية المخزون عندما ينخفض متغيّر إلى حده الحرج. لا يتكرر الإشعار ما دام دون الحد؛ ويُرسل مجددًا إذا أُعيد تزويده بالمخزون ثم انخفض مرة أخرى.',
      },
      restock_customers: {
        name: 'عودة المخزون ← إشعار العملاء الموافقين',
        text: 'يُرسل بريد إلكتروني إلى العملاء الذين طلبوا «أعلمني عند التوفر» عندما يعود المنتج إلى المخزون (الطلب نفسه يُعد موافقة؛ وتُطبَّق قائمة الحظر وقائمة انتظار الإرسال). تتم إدارته في قسم «تنبيهات المخزون والأسعار».',
      },
      paid_order_flow: {
        name: 'دُفع الطلب ← التجهيز ← الفاتورة والشحن',
        text: 'ينقل الطلب المدفوع إلى «قيد المعالجة» (حُجز المخزون عند تقديم الطلب)، ويفتح مسودة فاتورة في BizimHesap، ويرسل بريدًا إلكترونيًا إلى أعضاء الفريق الذين لديهم صلاحية الشحن لتجهيزه.',
      },
      cart_reminder: {
        name: 'سلة متروكة ← التحقق من الموافقة ← تذكير',
        text: 'يرسله تدفق «سلة متروكة» ضمن «عمليات الأتمتة التسويقية»: يُتحقق قبل كل بريد إلكتروني من الموافقة التسويقية و İYS وقائمة الحظر وحد التكرار وساعات الهدوء.',
      },
      approved_post_schedule: {
        name: 'اعتُمد مقال جديد ← نشر مجدول',
        text: 'يجدول المقال الذي اعتمده المراجع المختص للنشر في الساعة 10:00 من اليوم التالي. لا يُنشر إذا تغيّر النص بعد الاعتماد (إذ لم يعد الاعتماد ساريًا).',
      },
      weekly_sales_report: {
        name: 'انتهى الأسبوع ← تقرير المبيعات ← بريد إلكتروني',
        text: 'كل يوم اثنين في الساعة 08:00 يُنشئ التقرير المحفوظ للأسبوع الماضي بصلاحيات كل مستلم الخاصة؛ ولا يحتوي البريد الإلكتروني إلا على رابط إلى «ملفات تقاريري».',
      },
      tls_expiring_alert: {
        name: 'اقتراب انتهاء صلاحية SSL ← تنبيه أمني',
        text: 'ينبّه مديري المتجر عندما يتبقى أقل من 14 يومًا على انتهاء صلاحية شهادة SSL لنطاق ما أو عندما يكون بها خلل؛ مرة واحدة لكل شهادة.',
      },
      payment_hook_failure: {
        name: 'خطأ في إشعار POS ← تنبيه عاجل',
        text: 'يرسل تنبيهًا عاجلًا إلى من لديهم صلاحية إعدادات الدفع عندما يُرفض إشعار (Webhook) أو رد استدعاء (Callback) من مزوّد الدفع أو تتعذّر معالجته؛ مرة واحدة في الساعة على الأكثر.',
      },
    },
    recentRuns: 'آخر عمليات التنفيذ',
    runsTitle: 'سجل التنفيذ',
    runsEmpty: 'لا توجد عمليات تنفيذ بعد.',
    runColumns: { event: 'الحدث', status: 'الحالة', progress: 'الإجراء', when: 'الوقت' },
    runStatuses: {
      pending: 'قيد الانتظار',
      running: 'قيد التنفيذ',
      succeeded: 'ناجح',
      failed: 'فاشل',
      skipped: 'تم التخطي',
      cancelled: 'ملغى',
    },
    progress: '{{done}}/{{total}}',
    nextAttempt: 'المحاولة التالية: {{date}}',
    back: 'مسارات الأتمتة',
    builderLegend: 'تعريف المسار',
    name: 'اسم المسار',
    description: 'الوصف',
    runAs: 'شغّله: {{name}} — تُنفَّذ الإجراءات بالصلاحيات الحالية لهذا الشخص.',
    activeEditNote:
      'المسار قيد التشغيل: يسري التغيير الذي تحفظه على الأحداث الجديدة، وسيعمل المسار باسمك من الآن فصاعدًا.',
    unsaved: 'توجد تغييرات غير محفوظة.',
    problemsTitle: 'أصلح ما يلي قبل تشغيل المسار',
    problemAction: 'الإجراء {{n}}',
    problemRule: 'الشرط {{n}}',
    save: 'حفظ',
    saved: 'تم حفظ المسار.',
    activate: 'تشغيل',
    activated: 'تم تشغيل المسار؛ ستُعالَج الأحداث من الآن فصاعدًا.',
    pause: 'إيقاف مؤقت',
    paused: 'تم إيقاف المسار مؤقتًا.',
    archive: 'أرشفة',
    archiveConfirm: 'سيُؤرشف المسار ولن يمكن تشغيله مرة أخرى؛ ويُحتفظ بسجل التنفيذ. هل تريد المتابعة؟',
    archived: 'تمت أرشفة المسار.',
    step1: 'المشغّل',
    step2: 'الشروط',
    step3: 'الإجراءات',
    trigger: 'متى؟',
    triggers: {
      product_created: 'أُضيف منتج',
      price_changed: 'تغيّر سعر',
      stock_critical: 'انخفض المخزون إلى المستوى الحرج',
      payment_captured: 'دُفع طلب',
      post_approved: 'حصل مقال على اعتماد المراجع المختص',
      schedule: 'انتهت فترة (التقويم)',
      tls_expiring: 'شهادة SSL على وشك الانتهاء',
      payment_webhook_failed: 'تعذّرت معالجة إشعار الدفع (POS)',
      integration_error: 'فشل اختبار اتصال',
    },
    triggerHints: {
      product_created: 'كل منتج جديد يُضاف من لوحة التحكم أو عبر الاستيراد أو النسخ يُعد حدثًا.',
      price_changed:
        'يُعد حدثًا كلٌّ من تغيير سعر منفرد، وعملية تسعير جماعية (والتراجع عنها)، وتحديث سعر الصرف.',
      stock_critical:
        'مطابق لقواعد المخزون الحرج في تقرير المخزون: الكمية القابلة للبيع مساوية للحد أو أقل منه. دخول متغيّر/مستودع إلى القائمة لأول مرة يُعد حدثًا؛ أما ما كان حرجًا بالفعل عند تشغيل المسار فلا يُحتسب.',
      payment_captured: 'كل دفعة تُحصَّل بالبطاقة أو عبر POS أو عبر «تم استلام الدفعة» تُعد حدثًا.',
      post_approved: 'يقع حدث عندما يعتمد طبيب بيطري/مراجع مختص مقالًا صحيًا.',
      schedule:
        'يعمل مرة واحدة في اليوم والوقت اللذين تختارهما (بتوقيت تركيا) للفترة المنتهية: أمس، أو الأسبوع الماضي (الاثنين–الأحد)، أو الشهر الماضي.',
      tls_expiring:
        'نطاق تقترب صلاحية شهادته من الانتهاء أو بها خلل وفقًا لفحص النطاقات؛ حدث واحد لكل شهادة.',
      payment_webhook_failed:
        'يقع حدث عندما يُرفض إشعار أو رد استدعاء (Callback) وارد من مزوّد الدفع (توقيع غير صالح وغير ذلك) أو تتعذّر معالجته.',
      integration_error: 'يقع حدث عندما يفشل أحد اختبارات الاتصال في الإعدادات.',
    },
    frequencies: {
      daily: 'يومي (أمس)',
      weekly: 'أسبوعي (الأسبوع الماضي)',
      monthly: 'شهري (الشهر الماضي)',
    },
    weekdays: {
      '1': 'الاثنين',
      '2': 'الثلاثاء',
      '3': 'الأربعاء',
      '4': 'الخميس',
      '5': 'الجمعة',
      '6': 'السبت',
      '7': 'الأحد',
    },
    noFields: 'لا توجد حقول شروط لهذا المشغّل؛ تُنفَّذ الإجراءات عند كل حدث.',
    noConditions: 'لا توجد شروط: تُنفَّذ الإجراءات عند كل حدث.',
    match: 'الشروط',
    matches: { all: 'يجب تحقق جميعها', any: 'يكفي تحقق أحدها' },
    addRule: 'إضافة شرط',
    ruleN: 'الشرط {{n}}',
    removeRuleN: 'إزالة الشرط {{n}}',
    ruleField: 'الحقل',
    ruleOp: 'المقارنة',
    ruleValue: 'القيمة',
    ruleValueMoney: 'المبلغ (TRY)',
    ruleResult: { true: 'تحقق', false: 'لم يتحقق' },
    fields: {
      title: 'الاسم / العنوان',
      status: 'الحالة',
      variantCount: 'عدد المتغيرات',
      brand: 'العلامة التجارية',
      source: 'نوع التغيير',
      priceList: 'قائمة الأسعار',
      sku: 'SKU',
      product: 'المنتج',
      available: 'الكمية القابلة للبيع',
      threshold: 'الحد',
      warehouse: 'المستودع',
      scope: 'نوع الحد',
      number: 'رقم الطلب',
      amount: 'المبلغ',
      currency: 'العملة',
      provider: 'المزوّد',
      channel: 'القناة',
      store: 'المتجر',
      published: 'النسخة المعتمدة منشورة',
      host: 'النطاق',
      daysLeft: 'الأيام المتبقية',
      state: 'الوضع',
      kind: 'نوع الإشعار',
      outcome: 'النتيجة',
      message: 'الرسالة',
      environment: 'البيئة',
    },
    options: {
      draft: 'مسودة',
      active: 'نشط',
      archived: 'مؤرشف',
      single: 'سعر منفرد',
      bulk: 'عملية جماعية',
      revert: 'التراجع عن عملية جماعية',
      fx: 'تحديث سعر الصرف',
      warehouse: 'حد المستودع',
      variant: 'حد المنتج',
      default: 'الحد الافتراضي',
      web: 'واجهة المتجر',
      b2b: 'موزّع',
      manual: 'لوحة التحكم',
      api: 'API',
      expiring: 'على وشك الانتهاء',
      error: 'به خلل',
      webhook: 'إشعار (Webhook)',
      callback: 'رد استدعاء (Callback)',
      rejected: 'مرفوض',
      sandbox: 'تجريبي',
      live: 'مباشر',
      yes: 'نعم',
      no: 'لا',
    },
    ops: {
      eq: 'يساوي',
      neq: 'لا يساوي',
      gt: 'أكبر من',
      gte: 'لا يقل عن',
      lt: 'أصغر من',
      lte: 'لا يزيد على',
      contains: 'يحتوي على',
      not_contains: 'لا يحتوي على',
      is_true: 'نعم',
      is_false: 'لا',
    },
    actions: {
      notify_staff: 'إرسال بريد إلكتروني إلى الفريق',
      seo_check: 'فحص SEO',
      merchant_sync: 'المزامنة مع Merchant Center (الخلاصة)',
      record: 'سجل التغيير',
      order_processing: 'نقل الطلب إلى «قيد المعالجة»',
      invoice_draft: 'مسودة فاتورة (BizimHesap)',
      publish_post: 'نشر المقال أو جدولته',
      send_report: 'إرسال تقرير محفوظ',
    },
    actionHints: {
      notify_staff:
        'يُرسل إلى أعضاء لوحة التحكم (الفريق) فقط؛ ولا تُرسل أي رسالة إلى العملاء. يتضمن البريد الإلكتروني اسم المسار والحدث ورابطًا إلى سجل التنفيذ.',
      seo_check: 'يفحص المنتج وفق قواعد «مركز SEO» (حتى إن لم يُنشر بعد). تُدرج المشكلات في سجل الخطوات.',
      merchant_sync:
        'تُرسل منتجات المتجر المختار إلى Merchant Center (ولا يُعاد إرسال ما لم يتغيّر). إذا لم يوجد اتصال بـ Google تُتخطّى الخطوة بحالة «يتطلب الإعداد».',
      record: 'يسجّل الحدث وحقوله في سجل التدقيق بوصفه «سجل أتمتة».',
      order_processing:
        'لا يُنقل إلى «قيد المعالجة» إلا الطلب الذي في حالة «مدفوع»؛ وإذا كان الفريق قد نقله بالفعل فلا يُمس. حُجز المخزون عند تقديم الطلب ويُخصم عند الشحن.',
      invoice_draft:
        'يفتح مسودة في BizimHesap إذا لم تكن للطلب فاتورة. إذا كان الإرسال مفعّلًا يُنشأ e-Arşiv/e-Fatura؛ ولا يُكرَّر تلقائيًا الإرسال غير المؤكد أو المرفوض.',
      publish_post: 'ينشر المقال المعتمد أو يجدوله لوقت لاحق. لا يُنشر إذا تغيّر النص بعد الاعتماد.',
      send_report:
        'يُنشئ التقرير المحفوظ للفترة بصلاحيات كل مستلم الخاصة ويضعه في «ملفات تقاريري»؛ ولا يحتوي البريد الإلكتروني على أي بيانات من التقرير.',
    },
    actionN: 'الإجراء {{n}}',
    addAction: 'إضافة إجراء',
    moveUpN: 'نقل الإجراء {{n}} إلى الأعلى',
    moveDownN: 'نقل الإجراء {{n}} إلى الأسفل',
    removeActionN: 'إزالة الإجراء {{n}}',
    notAllowed: '(لا تملك الصلاحية)',
    incompatible: '(غير متاح لهذا المشغّل)',
    choose: 'اختر',
    params: {
      days: 'عدد الأيام قبل الانتهاء',
      frequency: 'التكرار',
      weekday: 'اليوم',
      monthDay: 'يوم الشهر',
      hour: 'الوقت (بتوقيت تركيا)',
      recipients: 'إلى',
      permission: 'الصلاحية',
      userIds: 'الأشخاص',
      subject: 'موضوع البريد الإلكتروني',
      message: 'الرسالة (اختياري)',
      stopOnIssues: 'لا تتابع إلى الإجراءات التالية إذا وُجدت مشكلات SEO',
      storeId: 'المتجر',
      note: 'ملاحظة السجل (اختياري)',
      send: 'أرسل المسودة إلى BizimHesap فورًا (يُنشئ e-Arşiv/e-Fatura)',
      mode: 'متى',
      hours: 'بعد كم ساعة',
      savedReportId: 'التقرير المحفوظ',
      format: 'تنسيق الملف',
      recipientIds: 'المستلمون',
    },
    recipientsModes: { permission: 'كل من لديه هذه الصلاحية', users: 'أشخاص أختارهم' },
    placeholders: 'الحقول التي يمكن استخدامها في النص: {{list}}',
    publishModes: { now: 'فورًا', delay: 'بعد عدد من الساعات', next_day: 'في اليوم التالي في وقت محدد' },
    reportNone: 'لا يوجد تقرير محفوظ؛ احفظ تقريرًا في منشئ التقارير أولًا.',
    advanced: 'الحدود',
    throttle: 'فترة الانتظار بعد التنفيذ (بالدقائق)',
    throttleNote:
      '0 = بلا انتظار. تحدّ من التكرار في الأحداث الكثيرة التكرار؛ وتُسجَّل الأحداث الواردة خلال هذه الفترة بحالة «تم التخطي».',
    rate: 'الحد الأقصى لعدد عمليات التنفيذ في الساعة',
    rateNote:
      'عند تجاوزه يتوقف المسار تلقائيًا ويُرسل بريد إلكتروني إلى المديرين (حماية من الحلقات والإغراق).',
    test: 'التجربة مع الأحداث الأخيرة',
    testTitle: 'نتيجة التشغيل التجريبي',
    testNote: 'قُيّمت الشروط وفق الأحداث الأخيرة للمشغّل؛ لم يُنفَّذ أي إجراء ولم يتغيّر أي شيء.',
    testEmpty: 'لا توجد أحداث لهذا المشغّل بعد.',
    matched: 'الشروط متحققة — كانت الإجراءات ستُنفَّذ',
    notMatched: 'الشروط غير متحققة — كان سيُتخطّى',
    outOfScope: 'خارج نطاق متاجرك — كان سيُتخطّى',
    statusFilter: 'الحالة',
    runTitle: 'التنفيذ',
    triggerLabel: 'المشغّل',
    event: 'الحدث',
    eventKey: 'مفتاح الحدث',
    createdAt: 'وقت استلام الحدث',
    finishedAt: 'وقت الانتهاء',
    reasonLabel: 'السبب',
    lastError: 'آخر خطأ',
    attempts: 'إعادة المحاولة',
    fieldsTitle: 'حقول الحدث',
    conditionsTitle: 'الشروط',
    stepsTitle: 'سجل الخطوات',
    stepsEmpty: 'لم يُنفَّذ أي إجراء بعد.',
    remaining: 'إجراءات لم تُنفَّذ: {{list}}',
    outcomes: { succeeded: 'ناجح', skipped: 'تم التخطي', stopped: 'أوقف المسار', failed: 'خطأ' },
    attempt: 'المحاولة {{n}}',
    reasons: {
      conditions_not_met: 'لم تتحقق الشروط.',
      throttled: 'ورد قبل انتهاء فترة الانتظار.',
      store_scope: 'خارج نطاق متاجر الشخص الذي شغّل المسار.',
      workflow_paused: 'تم إيقاف المسار مؤقتًا.',
      workflow_archived: 'تمت أرشفة المسار.',
      manual: 'أُلغي يدويًا.',
      manual_retry: 'أُعيدت المحاولة يدويًا.',
      stopped: 'أوقف أحد الإجراءات المسار',
    },
    codes: {
      not_configured: 'يتطلب الإعداد: لا يوجد اتصال أو أنه غير مكتمل؛ تم تخطي الخطوة.',
      internal_error: 'خطأ مؤقت؛ ستُعاد المحاولة.',
      forbidden: 'لا يملك الشخص الذي شغّل المسار صلاحية لهذا الإجراء.',
      unknown: 'رمز الخطأ: {{code}}',
    },
    detail: {
      issues: 'مشكلات SEO: {{list}}',
      recipients: 'عدد الأشخاص الذين أُرسل إليهم: {{count}}.',
      sent: 'المستلمون الذين أُرسل إليهم: {{sent}}، ومن تم تخطيهم: {{skipped}} (بلا صلاحية أو بعضوية مغلقة).',
      publishAt: 'وقت النشر: {{date}}',
      publishedNow: 'نُشر فورًا.',
      merchant: 'Merchant Center: مُرسَل {{inserted}}، محذوف {{deleted}}، دون تغيير {{unchanged}}.',
      orderStatus: 'حالة الطلب: {{status}}',
      invoice: 'الفاتورة: {{status}}',
      permission: 'الصلاحية المطلوبة: {{name}}',
    },
    invoiceStatuses: {
      draft: 'فُتحت مسودة',
      sending: 'قيد الإرسال',
      sent: 'أُرسلت',
      failed: 'تعذّر الإرسال',
      uncertain: 'النتيجة غير مؤكدة',
      cancelled: 'ملغاة',
    },
    retry: 'إعادة المحاولة',
    retried: 'أُعيد إدراج التنفيذ في قائمة الانتظار؛ وسيستأنف من الإجراء الذي توقف عنده.',
    cancel: 'إلغاء',
    cancelConfirm: 'سيُلغى التنفيذ قيد الانتظار ولن تُنفَّذ إجراءاته.',
    cancelledToast: 'تم إلغاء التنفيذ.',
  },
};
